import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@nab/shared/styles.css";
// Must precede App: initI18n sets the document's lang and dir before the first render.
import "./i18n";
import "./styles.css";

import { RouterProvider } from "@nab/shared";

import { App } from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("root element is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider>
      <App />
    </RouterProvider>
  </StrictMode>,
);
